import React from "react";
import classNames from "classnames";

type PROPS = {
  children: any
  checkbox?: boolean
  className?: string
  mandatory?: boolean
  title?: any
  withAdditionalEl?: boolean
}

export const Field = (props: PROPS) => {
  const {
    children,
    checkbox,
    className = '',
    mandatory,
    title,
    withAdditionalEl
  } = props;

  const cls = classNames(
    `k-form-field ${className}`,
    {
      'k-form-field-checkbox': checkbox,
      'tp-with-additional-element': withAdditionalEl,
      'k-mandatory': mandatory
    }
  );

  return (
    <div
      className={cls}
      title={title}
    >
      {children}
    </div>
  );
}